import React from "react";
import "../../../css/admin.css";
import Icon from "../../../components/Icon";
import { useTranslation } from "react-i18next";

function PlanCard({widgets={},data={}}) {
  const { t } = useTranslation();
 

  const renderGrowth = (cur, prev) => {
    const diff = cur - prev;
    let percentage = 0;
    if (prev !== 0) {
      percentage = (diff / prev) * 100;
    }
    return Math.abs(percentage || 0).toFixed(2);
  };

  const renderIconName = (cur, prev) => {
    const diff = cur - prev;
    if (diff >= 0) {
      return "upArrow";
    }
    return "downArrow";
  };


  const current_amount = (
    (data?.current_month_stats?.amount + data?.current_month_stats?.offlineAmount) || data?.current_month_total_revenue || 0
  ).toFixed(2);
  const pending_amount = (
    data?.current_month_pending_revenue || 0
  ).toFixed(2);

  return (
    <div>
      <div className="row">
        {widgets?.showTotalIncome && (
          <div className="col-lg-4 col-md-4">
            <div className="chart-box">
              <div className="d-flex">
                <Icon
                  iconName="TotalDonation"
                  width="85px"
                  height="84px"
                  mr="15px"
                  mt="15px"
                />
                <div>
                  <small>
                    {t("Total")} <br />
                    {t("Income")}
                  </small>
                  <h1>{`€${current_amount}`}</h1>
                  <p className="d-flex align-items-center">
                    <Icon
                      iconSize="tiny"
                      color="#00AC4F"
                      iconName={renderIconName(
                        data?.current_month_total_revenue,
                        data?.last_month_total_revenue
                      )}
                    />
                    <label className={"green"}>
                      {renderGrowth(
                        data?.current_month_total_revenue,
                        data?.last_month_total_revenue
                      )}
                      %
                    </label>
                    {t("this month")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {widgets?.showInprogressIncome && (
          <div className="col-lg-4 col-md-4">
            <div className="chart-box">
              <div className="d-flex">
                <Icon
                  iconName="PendingDonations"
                  width="85px"
                  height="84px"
                  mr="15px"
                  mt="15px"
                />
                <div>
                  <small>
                    {t("Income")} <br />
                    {t("In Progress")}
                  </small>
                  <h1>{`€${pending_amount}`}</h1>
                  <p className="d-flex align-items-center">
                    <Icon
                      iconSize="tiny"
                      color="#FECB17"
                      iconName={renderIconName(
                        data?.current_month_pending_revenue,
                        data?.last_month_pending_revenue
                      )}
                    />
                    <label className={"yellow"}>
                      {renderGrowth(
                        data?.current_month_pending_revenue,
                        data?.last_month_pending_revenue
                      )}
                      %
                    </label>
                    {t("this month")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {widgets?.showTotalAffiliatedMosques && (
          <div className="col-lg-4 col-md-4">
            <div className="chart-box">
              <div className="d-flex">
                <Icon
                  iconName="Userpaid"
                  width="85px"
                  height="84px"
                  mr="15px"
                  mt="15px"
                />
                <div>
                  <small>
                    {t("Total Number of Unpaid Users")} / <br />
                    {t("Total Number of Paid Users")}
                  </small>
                  <h1>
                    {`${data?.currentMonthTotalUnPaidUsers || 0}`} /{" "}
                    {`${data?.currentMonthTotalPaidUsers || 0}`}
                  </h1>
                  <p className="d-flex align-items-center">
                    <Icon
                      iconSize="tiny"
                      color="#4763E4"
                      iconName={renderIconName(
                        data?.current_month_stats?.count,
                        data?.last_month_stats?.count
                      )}
                    />
                    <label className={"blue"}>
                      {renderGrowth(
                        data?.current_month_stats?.count,
                        data?.last_month_stats?.count || 0
                      )}
                      %
                    </label>
                    {t("this month")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {widgets?.showTotalMosques && (
          <div className="col-lg-4">
            <div className="chart-box h-100">
              <div className="d-flex">
                <Icon
                  iconName="Userpaid"
                  width="85px"
                  height="84px"
                  mr="15px"
                  mt="10px"
                />
                <div className="d-flex flex-column justify-content-center">
                  <small>{t("Affiliated Mosques")}</small>
                  <h1>{`${data?.current_month_onboarded_count}`}</h1>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PlanCard;
